import {createSelector} from '@reduxjs/toolkit'
import {RootState} from 'app/rootReducer'
import {SliceStatus} from 'interfaces'
import {PoliciesState} from './policiesSlice'

function getPolicies(state: RootState): PoliciesState {
  return state.policies
}

export const selectPolicies = createSelector(getPolicies, policies => policies)
export const isDeleteStatusPending = createSelector(getPolicies, policies => {
  return policies?.deletePolicyStatus === SliceStatus.pending
})
export const selectShowCreatePolicyRP = createSelector(
  getPolicies,
  policies => policies?.showCreatePolicyRP,
)
